<!-- Center canvas: the banner image for the current device, matching the
     mockup's banner card. In Edit mode it's an image slot (appInlineMedia):
     click or drop a file to replace the image shown. -->
<div class="cr-mb-card" *ngIf="isPreview">
  <span class="cr-mb-badge">Main Banner</span>

  <div
    class="cr-mb-dropzone"
    [attr.id]="currentDeviceImage ? block.blockId : null"
    [appInlineMedia]="currentDeviceImage"
    [inlineMediaBlockId]="block.blockId"
    (inlineMediaChange)="onChange($event, currentDeviceImageKey)"
  >
    <a *ngIf="currentDeviceImage; else emptyPreview" [href]="previewHref" target="_blank" rel="noopener">
      <img [src]="currentDeviceImage" [alt]="block.variables?.['MainBannerAlt'] || ''" />
    </a>

    <ng-template #emptyPreview>
      <div class="cr-inline-media-icon">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-inline-media-title">Upload image</div>
      <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
    </ng-template>
  </div>
</div>

<!-- Right panel: real edit form (image upload, redirect link + segment, alt text) -->
<div class="cr-mb-edit" *ngIf="!isPreview">
  <div class="cr-mb-field-row">
    <span class="cr-mb-field-label">Desktop Image</span>
    <span
      class="cr-mb-toggle"
      [class.cr-mb-toggle-on]="desktopImageAsUpload"
      role="button"
      tabindex="0"
      [title]="desktopImageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleDesktopImageMode()"
      (keydown.enter)="toggleDesktopImageMode()"
      (keydown.space)="toggleDesktopImageMode()"
    ></span>
  </div>
  <div class="cr-mb-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['MainBannerImageDesktop'] ?? ''"
      (handleOnChange)="onChange($event, 'MainBannerImageDesktop')"
      [placeholder]="imageDesktopPlaceholder"
      variable="MainBannerImageDesktop"
      [isImage]="desktopImageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-mb-empty-overlay" *ngIf="desktopImageAsUpload && !block.variables?.['MainBannerImageDesktop']">
      <div class="cr-mb-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-mb-title">Upload image</div>
      <div class="cr-mb-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-mb-field-row">
    <span class="cr-mb-field-label">Mobile Image</span>
    <span
      class="cr-mb-toggle"
      [class.cr-mb-toggle-on]="mobileImageAsUpload"
      role="button"
      tabindex="0"
      [title]="mobileImageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleMobileImageMode()"
      (keydown.enter)="toggleMobileImageMode()"
      (keydown.space)="toggleMobileImageMode()"
    ></span>
  </div>
  <div class="cr-mb-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['MainBannerImageMobile'] ?? ''"
      (handleOnChange)="onChange($event, 'MainBannerImageMobile')"
      [placeholder]="imageMobilePlaceholder"
      variable="MainBannerImageMobile"
      [isImage]="mobileImageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-mb-empty-overlay" *ngIf="mobileImageAsUpload && !block.variables?.['MainBannerImageMobile']">
      <div class="cr-mb-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-mb-title">Upload image</div>
      <div class="cr-mb-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-mb-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['MainBannerHref'] ?? ''"
      (handleOnChange)="onChange($event, 'MainBannerHref')"
      [placeholder]="hrefPlaceholder"
      variable="MainBannerHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'MainBannerHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['MainBannerHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-mb-alt-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="alt"
      [blockData]="block.variables?.['MainBannerAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'MainBannerAlt')"
      [placeholder]="altPlaceholder"
      variable="MainBannerAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>
</div>
